import { render, staticRenderFns } from "./AppMenuEntry.vue?vue&type=template&id=9736071a&scoped=true"
import script from "./AppMenuEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuEntry.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMenuEntry.vue?vue&type=style&index=0&id=9736071a&prod&scoped=true&lang=scss"
import style1 from "./AppMenuEntry.vue?vue&type=style&index=1&id=9736071a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9736071a",
  null
  
)

export default component.exports